// @core/api/endpoints/payment/create_payment_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePaymentProviderRequest,
  CreatePaymentProviderResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Create payment provider
 * Registers a new payment service provider (Stripe, Adyen, PayPal, etc.) with credentials and capabilities.
 */
export async function CreatePaymentProvider(
  data: CreatePaymentProviderRequest,
  options?: RequestOptions
): Promise<CreatePaymentProviderResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-providers`;
  const requestOptions = options;
  return client.post<CreatePaymentProviderResponse>(requestPath, data, requestOptions);
}
